"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkData = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _ZBKJIutil = require("@/utils/ZBKJIutil");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var JavaMerchantId = _jsCookie.default.get('JavaMerchantId');
var linkData = exports.linkData = {
  list: [{
    id: 1,
    type: 1,
    name: '商品分类',
    url: "/pages/merchant/classify_coupon/index?id=".concat(JavaMerchantId, "&tabActive=1")
  }, {
    id: 2,
    type: 1,
    name: '商品列表',
    url: "/pages/goods/goods_list/index?merId=".concat(JavaMerchantId)
  }, {
    id: 3,
    type: 1,
    name: '优惠券列表',
    url: "/pages/merchant/classify_coupon/index?id=".concat(JavaMerchantId, "&tabActive=2")
  }, {
    id: 4,
    type: 1,
    name: '商户详情',
    url: "/pages/merchant/detail/index?merId=".concat(JavaMerchantId)
  }, {
    id: 5,
    type: 1,
    name: '联系客服',
    url: (0, _ZBKJIutil.getServiceInfo)()
  }],
  merchantList: [{
    id: 1,
    type: 1,
    name: '店铺主页',
    url: "/pages/merchant/home/index?merId=".concat(JavaMerchantId)
  }, {
    id: 2,
    type: 1,
    name: '商品列表',
    url: "/pages/goods/goods_list/index?merId=".concat(JavaMerchantId)
  }]
};